import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { path: "/", label: "首页" },
    { path: "/category/image-text", label: "图文素材" },
    { path: "/category/video", label: "原创视频" },
    { path: "/category/creative", label: "创意素材" },
    { path: "/category/template", label: "设计模板" },
    { path: "/about", label: "关于我们" },
  ];

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full" aria-label="主导航">
        <div className="px-4 md:px-6 flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-global-line text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-lg font-semibold transition-colors duration-300 ${scrolled ? "text-foreground-900" : "text-background-50"}`}>
              海角千万资源原创
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive(link.path)
                    ? scrolled
                      ? "text-primary-500 bg-primary-50"
                      : "text-background-50 bg-white/20"
                    : scrolled
                      ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                      : "text-background-50/80 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile toggle */}
          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center rounded-md transition-colors duration-200 ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
            <div className="px-4 py-3 flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    isActive(link.path)
                      ? "text-primary-500 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}